// extracted by mini-css-extract-plugin
module.exports = {"badge":"profile-image-skins-xxlargeOnWide-badge-d0d92ea9"};